
import React, { useEffect } from 'react';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
    message: string;
    type: ToastType;
    onClose: () => void;
    duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 5000 }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration]);

    const bgColor = {
        success: 'bg-purple-500',
        error: 'bg-red-500',
        info: 'bg-blue-600',
    }[type];

    const IconComponent = {
        success: CheckCircle,
        error: XCircle,
        info: Info,
    }[type];

    return (
        <div className="fixed bottom-8 right-8 z-[100] animate-in fade-in slide-in-from-right-10 duration-300">
            <div className={`${bgColor} text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-4 min-w-[300px]`}>
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                    <IconComponent className="w-5 h-5" />
                </div>
                <div className="flex-grow">
                    <p className="font-bold text-sm">{message}</p>
                </div>
                <button
                    onClick={onClose}
                    className="hover:scale-110 transition-transform p-1 opacity-70 hover:opacity-100"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default Toast;
